import React, { useRef } from 'react';
import classNames from 'classnames';
import { hookUtils } from '@indico-data/utils';
import { Icon } from 'Permafrost/index';
import { StyledContextMenu } from './ChartContextMenu.styles';
export function ChartContextMenu(props) {
    const { closeMenuHandler, xPos, yPos, options, currentDatum } = props;
    const menuEl = useRef();
    hookUtils.useClickOutside(menuEl, closeMenuHandler);
    const onItemClicked = (itemHandler) => {
        itemHandler(currentDatum);
        props.closeMenuHandler();
    };
    return (React.createElement(StyledContextMenu, { style: { top: yPos, left: xPos }, ref: menuEl }, options.map((option, index) => {
        const disabled = option.filter && !option.filter(currentDatum);
        return (React.createElement("li", { key: index, className: classNames({
                disabled,
            }) },
            React.createElement("a", { href: "/", onClick: (e) => {
                    e.preventDefault();
                    return !disabled && onItemClicked(option.handler);
                } },
                option.icon ? option.icon : React.createElement(Icon, { name: "fa-square" }),
                " ",
                option.name)));
    })));
}
//# sourceMappingURL=ChartContextMenu.js.map